import React from "react";
import { Form } from "react-bootstrap";

const PillSelect = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  className = "",
  style = {},
  disabled = false,
}) => (
  <Form.Group className={`pill-select-group ${className}`} style={style}>
    {label && (
      <Form.Label>
        {label}
        {required && <span className="requiresLable"> *</span>}
      </Form.Label>
    )}
    <Form.Select
      name={name}
      value={value}
      onChange={onChange}
      className="pill-select"
      disabled={disabled}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
);

export const LABEL_OPTIONS = [
  { value: "Delivery point", label: "Delivery point" },
  { value: "Loading point", label: "Loading point" },
];

export default PillSelect;
